import Checkbox from 'components/common/form/Checkbox';
import CheckboxGroup from 'components/common/form/CheckboxGroup';
import FilterElementLayout from '../FilterElementLayout';
import * as React from 'react';
import { CheckboxGroupChangeEventHandler } from 'types/common/checkbox';
import { CheckBoxFilterOption, CheckBoxFilterValue } from 'types/common/searchfilter';

interface Props<T = CheckBoxFilterValue> {
  values: T[];
  onChange: CheckboxGroupChangeEventHandler<T>;
  options: CheckBoxFilterOption<T>[];
  label: string;
}

const CheckboxFilterElement = <T extends unknown>({
  options,
  values,
  onChange,
  label,
}: Props<T>) => {
  return (
    <FilterElementLayout label={label} gridSize={1}>
      <CheckboxGroup value={values} onChange={onChange}>
        {options.map(({ label, value }, index) => (
          <Checkbox label={label} value={value} key={index} color={'primary'} />
        ))}
      </CheckboxGroup>
    </FilterElementLayout>
  );
};

export default CheckboxFilterElement;
